import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSetRecoilState, useRecoilState } from "recoil";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import TransferApiDireto from "../../../../services/TransferApiDireto"; // Correct import
import { customColors } from "../../../../atoms/customColors";

export default function ModalDeleteConfirmation({
  isOpen,
  setIsOpen,
  getTransferList,
  id,
}: any) {
  const finalRef = React.useRef(null);
  const navigate = useNavigate();
  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];
  const colors = useRecoilState(customColors)[0];
  const [isLoading, setIsLoading] = useState(false);

  const onClose = () => {
    setIsOpen(false);
  };

  async function cancelSolicitation() {
    try {
      setIsLoading(true);
      const response = await TransferApiDireto.deleteTransferPerId(id, {}); // Pass empty object as second argument
      toast.success("Solicitação Cancelada com Sucesso!");
      getTransferList();
      setRefreshGlobal(refresh + 1);
      onClose();
    } catch (error) {
      console.log("error:", error);
      toast.error("Não foi possível cancelar a solicitação!");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Modal
      finalFocusRef={finalRef}
      isOpen={isOpen}
      onClose={onClose}
      size={"xl"}
    >
      <ModalOverlay backdropFilter="blur(10px)" />
      <ModalContent>
        <ModalHeader>
          <Flex w={"100%"} justifyContent={"center"}>
            <Text fontWeight={"bold"}>Deseja Cancelar a Transferência?</Text>
          </Flex>
        </ModalHeader>
        <ModalBody>
          <Text>
            Você está prestes a cancelar a transferência com ID {id}. Esta ação
            não pode ser desfeita. Deseja continuar?
          </Text>
        </ModalBody>
        <ModalFooter justifyContent={"space-evenly"}>
          <Button
            background={colors.GRAY}
            color={"white"}
            mr={3}
            onClick={onClose}
            isDisabled={isLoading}
          >
            Voltar
          </Button>
          <Button
            background={colors.REDMONEDD}
            color={"white"}
            mr={3}
            onClick={cancelSolicitation}
            isLoading={isLoading}
          >
            Cancelar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
